var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tabs" },
    [
      _vm._l(_vm.tabs, function(tab) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeLayout === 1 && tab.open,
                expression: "activeLayout === 1 && tab.open"
              }
            ],
            key: tab.name,
            staticClass: "tab navTab",
            class: { "selected-tab": _vm.activeTab.name === tab.name },
            on: {
              click: function($event) {
                return _vm.selectTab(tab)
              }
            }
          },
          [
            _vm._v("\n    " + _vm._s(_vm.$tc(tab.display, 2)) + "\n    "),
            tab.name !== "home"
              ? _c("span", {
                  staticClass: "tab-close-button",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.removeTab(tab)
                    }
                  }
                })
              : _vm._e()
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabCreator && _vm.activeLayout === 1,
              expression: "tabCreator && activeLayout === 1"
            },
            {
              name: "on-clickaway",
              rawName: "v-on-clickaway",
              value: _vm.hideTabMenu,
              expression: "hideTabMenu"
            }
          ],
          staticClass: "tab-create-container"
        },
        [
          _c(
            "v-btn",
            {
              staticClass: "open-tab-button ma-0",
              attrs: {
                text: "",
                height: "40",
                width: "40",
                disabled: _vm.disabledMenuButton
              },
              on: { click: _vm.toggleTabMenu }
            },
            [
              _c(
                "v-icon",
                {
                  staticStyle: { "line-height": "0" },
                  attrs: { size: "17", color: "#FFF" }
                },
                [_vm._v(" add_circle")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tabMenuOpen,
                  expression: "tabMenuOpen"
                }
              ],
              staticClass: "tab-menu"
            },
            _vm._l(_vm.tabs, function(tab) {
              return tab.name !== "home" && (_vm.isSuperAdmin || !tab.dev)
                ? _c(
                    "div",
                    {
                      key: tab.name,
                      staticClass: "tab-menu-option",
                      class: {
                        "disabled-tab-button": tab.open || tab.disabled
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.createTab(tab)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$tc(tab.display, 2)) +
                          "\n        "
                      ),
                      tab.dev
                        ? _c("dev-tag", {
                            style: { zoom: "80%", "margin-left": "20px" },
                            attrs: { position: "relative" }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            }),
            0
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e74e760", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e74e760","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/NavBar/TabsManagement.vue
// module id = null
// module chunks = 